import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fefcfb' },
    '2': { value: '#fff7ed' },
    '3': { value: '#ffefd6' },
    '4': { value: '#ffdfb5' },
    '5': { value: '#ffd19a' },
    '6': { value: '#ffc182' },
    '7': { value: '#f5ae73' },
    '8': { value: '#ec9455' },
    '9': { value: '#f76b15' },
    '10': { value: '#ef5f00' },
    '11': { value: '#cc4e00' },
    '12': { value: '#582d1d' },
    a1: { value: '#c0400004' },
    a2: { value: '#ff8e0012' },
    a3: { value: '#ff9c0029' },
    a4: { value: '#ff91014a' },
    a5: { value: '#ff8b0065' },
    a6: { value: '#ff81007d' },
    a7: { value: '#ed6c008c' },
    a8: { value: '#e35f00aa' },
    a9: { value: '#f65e00ea' },
    a10: { value: '#ef5f00' },
    a11: { value: '#cc4e00' },
    a12: { value: '#431200e2' },
  },
  dark: {
    '1': { value: '#17120e' },
    '2': { value: '#1e160f' },
    '3': { value: '#331e0b' },
    '4': { value: '#462100' },
    '5': { value: '#562800' },
    '6': { value: '#66350c' },
    '7': { value: '#7e451d' },
    '8': { value: '#a35829' },
    '9': { value: '#f76b15' },
    '10': { value: '#ff801f' },
    '11': { value: '#ffa057' },
    '12': { value: '#ffe0c2' },
    a1: { value: '#ec360007' },
    a2: { value: '#fe6d000e' },
    a3: { value: '#fb6a0025' },
    a4: { value: '#ff590039' },
    a5: { value: '#ff61004a' },
    a6: { value: '#fd75045c' },
    a7: { value: '#ff832c75' },
    a8: { value: '#fe84389d' },
    a9: { value: '#fe6d15f7' },
    a10: { value: '#ff801f' },
    a11: { value: '#ffa057' },
    a12: { value: '#ffe0c2' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.orange.light.1}', _dark: '{colors.orange.dark.1}' } },
  '2': { value: { _light: '{colors.orange.light.2}', _dark: '{colors.orange.dark.2}' } },
  '3': { value: { _light: '{colors.orange.light.3}', _dark: '{colors.orange.dark.3}' } },
  '4': { value: { _light: '{colors.orange.light.4}', _dark: '{colors.orange.dark.4}' } },
  '5': { value: { _light: '{colors.orange.light.5}', _dark: '{colors.orange.dark.5}' } },
  '6': { value: { _light: '{colors.orange.light.6}', _dark: '{colors.orange.dark.6}' } },
  '7': { value: { _light: '{colors.orange.light.7}', _dark: '{colors.orange.dark.7}' } },
  '8': { value: { _light: '{colors.orange.light.8}', _dark: '{colors.orange.dark.8}' } },
  '9': { value: { _light: '{colors.orange.light.9}', _dark: '{colors.orange.dark.9}' } },
  '10': { value: { _light: '{colors.orange.light.10}', _dark: '{colors.orange.dark.10}' } },
  '11': { value: { _light: '{colors.orange.light.11}', _dark: '{colors.orange.dark.11}' } },
  '12': { value: { _light: '{colors.orange.light.12}', _dark: '{colors.orange.dark.12}' } },
  a1: { value: { _light: '{colors.orange.light.a1}', _dark: '{colors.orange.dark.a1}' } },
  a2: { value: { _light: '{colors.orange.light.a2}', _dark: '{colors.orange.dark.a2}' } },
  a3: { value: { _light: '{colors.orange.light.a3}', _dark: '{colors.orange.dark.a3}' } },
  a4: { value: { _light: '{colors.orange.light.a4}', _dark: '{colors.orange.dark.a4}' } },
  a5: { value: { _light: '{colors.orange.light.a5}', _dark: '{colors.orange.dark.a5}' } },
  a6: { value: { _light: '{colors.orange.light.a6}', _dark: '{colors.orange.dark.a6}' } },
  a7: { value: { _light: '{colors.orange.light.a7}', _dark: '{colors.orange.dark.a7}' } },
  a8: { value: { _light: '{colors.orange.light.a8}', _dark: '{colors.orange.dark.a8}' } },
  a9: { value: { _light: '{colors.orange.light.a9}', _dark: '{colors.orange.dark.a9}' } },
  a10: { value: { _light: '{colors.orange.light.a10}', _dark: '{colors.orange.dark.a10}' } },
  a11: { value: { _light: '{colors.orange.light.a11}', _dark: '{colors.orange.dark.a11}' } },
  a12: { value: { _light: '{colors.orange.light.a12}', _dark: '{colors.orange.dark.a12}' } },
  default: { value: { _light: '{colors.orange.light.9}', _dark: '{colors.orange.dark.9}' } },
  emphasized: { value: { _light: '{colors.orange.light.10}', _dark: '{colors.orange.dark.10}' } },
  fg: { value: { _light: 'white', _dark: 'white' } },
  text: { value: { _light: '{colors.orange.light.a11}', _dark: '{colors.orange.dark.a11}' } },
})

export default {
  name: 'orange',
  tokens,
  semanticTokens,
}
